export enum FLAGS {
	EDIT_SENSORS_DATA = 'info-360-edit-sensor-data',
	ADMIN_BILLING = 'info-360-admin-billing',
	MSI_INSTALLER_DOWNLOAD = 'info360-msi-download',
	CURRENCY_SELECTION = 'info360-currency-selection',
	SENSOR_CONFIG_RENDER_TIME_FIELD = 'info-360-sensor-config-render-time-field',
	HEARTBEAT_DISPLAY = 'info-360-admin-heartbeat',
	ADMIN_INTEGRATIONS = 'info-360-integrations-tab',
	INFO_360_ADMIN_OPCUA = 'info-360-admin-opcua',
	GG_DOWNGRADE_BUTTONS = 'info-360-implementation-downgrade',
	CYLINDRICAL_TANK = 'insight-earth-cylindrical-tank',
	BULK_SENSOR_DATA_DELETION = 'info360-bulk-sensor-data-deletion',
	INFO_360_ADMIN_OLEDB = 'info-360-admin-oledb',
	ENABLE_VIRTUAL_SENSORS_ON_SENSOR_CONFIGURATION = 'ENABLE_VIRTUAL_SENSORS_ON_SENSOR_CONFIGURATION',
	ENABLE_MUIX_TABLE_FOR_SENSOR_CONFIGURATION = 'ENABLE_MUIX_TABLE_FOR_SENSOR_CONFIGURATION',
	ENABLE_SENSOR_PEEK_TROUBLESHOOT = 'info-360-sensor-peek-troubleshoot',
	ENABLE_LAST_VALUE_FOR_SENSOR_CONFIGURATION = 'ENABLE_LAST_VALUE_FOR_SENSOR_CONFIGURATION',
	ENABLE_HEALTH_STATUS_FOR_SENSOR_CONFIGURATION = 'ENABLE_HEALTH_STATUS_FOR_SENSOR_CONFIGURATION',
	IMPLEMENTATION_GLOBAL_MSI = 'info-360-implementation-global-msi',
	ENABLE_IOT_ACTIVATION = 'info-360-admin-iot-activation',
	USER_READONLY_ADMIN = 'info-360-admin-read-only-for-users',
	ENABLE_MUIX_TABLE_FOR_LOCATE_IN_MAP = 'ENABLE_MUIX_TABLE_FOR_LOCATE_IN_MAP',
	RESAMPLE_JOBS = 'info-360-admin-resample-jobs',
	REGENERATE_TILES_SENSOR = 'i-360-release-145733-regenerate-tiles-sensor',
	DONT_REQUIRE_CREDENTIALS = 'i-360-release-145762-dont-require-credentials-to-update-ancillary-settings',
	NEW_SENSOR_SYSTEM_TESTS = 'i-360-release-147077-fix-sensor-and-system-tests-to-avoid-30-sec-limit',
	NEW_SENSOR_SYSTEM_TESTS_TIMEOUT = 'i-360-configure-timeouts-147077-fix-sensor-and-system-tests-avoid-30-sec-limit',
	ENABLE_LAST_READ_DATE_TIME_SENSOR_CONFIGURATION = 'i-360-release-148791-add-last-reading-date-time-to-sensor-health',
	ENABLE_DYNAMIC_CERTS = 'i-360-release-154568-dynamic-certs',
	ENABLE_SENSOR_HEALTH_V3_API = 'i-360-release-161547-sensor-health-v-3-api',
	SENSOR_HEALTH_UNLOAD_LAG_MINUTES = 'i-360-configure-161547-sensor-health-unload-lag-minutes',
	MAP_MANAGEMENT = 'info-360-admin-map-management',
	TENANT_SPECIFIC_BE_COMPONENTS = 'i-360-release-162459-tenant-specific-be-components',
	ENABLE_NEW_DEPLOY_API = 'i-360-release-161536-migrate-deploygg-to-saas-edge-manager',
	ENABLE_GREENGRASS_PORTS_443 = 'i360i-allow-i360i-45-replace-greengrass-standard-ports-with-443',
	ENABLE_ALL_REGIONS_TEMPLATE_SHARING = 'info-360-enable-enable-all-regions-template-sharing',
}
